/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link, Redirect} from 'react-router-dom'

import http from '../../Component/Interceptor/Interseptor'
import cookie from 'react-cookies'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import USER_MANAGE from '../BaseComponent/USERMANAGE'

class AddWarehouse extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      warehouse: [],
      object: {},
      array: [],
      error: '',
      wareType: [],
      redirect: false,
      wareTypeStatus: '',
      Drivers: []
    }
  }

  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_PRIMARYWAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            wareType: response.data.object
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submitForm(e) {
    e.preventDefault()
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  changeWareType(e) {
    let value = e.target.value

    this.setState({
      wareTypeStatus: value
    })
  }

  submitWarehouse() {
    if (this.state.wareTypeStatus == '5') {
      let name = document.getElementById('name').value
      let driverId = document.getElementById('driverId').value
      let typePrimary = document.getElementById('typePrimary').value
      let externalId = this.convertDigit(document.getElementById('externalId').value)
      let sortOrder = this.convertDigit(document.getElementById('sortOrder').value)

      let nameError = false
      let typePrimaryError = false
      let addError = false
      let externalError = false
      let sortOrderError = false
      let driverIdError = false

      if (driverId == '') {
        driverIdError = true
        addError = true
        message.error('برای اضافه کردن انبارک,مشخص کردن رساننده الزامی است')
      } else {
        if (!driverIdError) {
          this.setState({
            error: ''
          })
        }
      }

      if (name == '') {
        nameError = true
        addError = true
        message.error('لطفا نام انبار را وارد کنید')
        this.setState({
          error: 'لطفا نام انبار را وارد کنید'
        })
      } else {
        if (!nameError) {
          this.setState({
            error: ''
          })
        }
      }
      if (typePrimary == '') {
        typePrimaryError = true
        addError = true
        message.error('لطفا نوع انبار را وارد کنید')

        this.setState({
          error: 'لطفا نوع انبار را وارد کنید'
        })
      } else {
        if (!typePrimaryError) {
          this.setState({
            error: ''
          })
        }
      }

      if (!(externalId == '') && !externalId.match(/[1-9\d]/g)) {
        externalError = true
        addError = true
        message.error('شناسه خارجی باید عدد صحیح باشد')
      } else {
        if (!externalError) {
          this.setState({
            error: ''
          })
        }
      }

      if (!(sortOrder == '') && !sortOrder.match(/[1-9\d]/g)) {
        sortOrderError = true
        addError = true
        message.error('اولویت انبار باید عدد صحیح باشد')
      } else {
        if (!sortOrderError) {
          this.setState({
            error: ''
          })
        }
      }

      if (!addError) {
        let data = {
          name: name,
          typePrimary: typePrimary,
          externalId: externalId == '' ? undefined : externalId,
          sortOrder: sortOrder == '' ? undefined : sortOrder,
          driverId
        }

        http
          .post(`${WAREHOUSE.WAREHOUSE_TYPE_ADD_WAREHOUSE}`, data, {})
          .then((response) => {
            if (response.data.error == null) {
              message.success('انبار با موفقیت اضافه شد')
              this.setState({
                redirect: true
              })
            } else {
              message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
            }
          })
          .catch((error) => {
            alert(JSON.stringify(error))
          })
      }
    } else {
      let name = document.getElementById('name').value
      let typePrimary = document.getElementById('typePrimary').value
      let externalId = this.convertDigit(document.getElementById('externalId').value)
      let sortOrder = this.convertDigit(document.getElementById('sortOrder').value)

      let nameError = false
      let typePrimaryError = false
      let addError = false
      let externalError = false
      let sortOrderError = false

      if (name == '') {
        nameError = true
        addError = true
        message.error('لطفا نام انبار را وارد کنید')
        this.setState({
          error: 'لطفا نام انبار را وارد کنید'
        })
      } else {
        if (!nameError) {
          this.setState({
            error: ''
          })
        }
      }
      if (typePrimary == '') {
        typePrimaryError = true
        addError = true
        message.error('لطفا نوع انبار را وارد کنید')

        this.setState({
          error: 'لطفا نوع انبار را وارد کنید'
        })
      } else {
        if (!typePrimaryError) {
          this.setState({
            error: ''
          })
        }
      }

      if (!(externalId == '') && !externalId.match(/[1-9\d]/g)) {
        externalError = true
        addError = true
        message.error('شناسه خارجی باید عدد صحیح باشد')
      } else {
        if (!externalError) {
          this.setState({
            error: ''
          })
        }
      }

      if (!(sortOrder == '') && !sortOrder.match(/[1-9\d]/g)) {
        sortOrderError = true
        addError = true
        message.error('اولویت انبار باید عدد صحیح باشد')
      } else {
        if (!sortOrderError) {
          this.setState({
            error: ''
          })
        }
      }

      if (!addError) {
        let data = {
          name: name,
          typePrimary: typePrimary,
          externalId: externalId == '' ? undefined : externalId,
          sortOrder: sortOrder == '' ? undefined : sortOrder
        }

        http
          .post(`${WAREHOUSE.WAREHOUSE_TYPE_ADD_WAREHOUSE}`, data, {})
          .then((response) => {
            if (response.data.error == null) {
              message.success('انبار با موفقیت اضافه شد')
              // this.setState({
              //     redirect: true
              // })
            } else {
              message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
            }
          })
          .catch((error) => {
            alert(JSON.stringify(error))
          })
      }
    }
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to="/WareHouseList" />
    }
  }

  submit(e) {
    e.preventDefault()
  }

  render() {
    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/WareHouseList'}>لیست انبار ها</Link>
            </li>
            <li>ثبت انبار</li>
          </ul>

          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت انبار</p>
            </div>
            <div className="formComponent">
              <label>
                نام انبار <span className="requireFiled">*</span>
              </label>
              <input type="text" className="form-control" id="name" name="name" />

              <label>
                نوع انبار <span className="requireFiled">*</span>
              </label>
              <select
                className="form-control"
                id="typePrimary"
                onChange={this.changeWareType.bind(this)}
                name="typePrimary"
              >
                <option value="">---------</option>
                {this.state.wareType.map((wareType, index) => (
                  <option key={index} value={wareType.id}>
                    {wareType.name}
                  </option>
                ))}
              </select>

              <div style={this.state.wareTypeStatus == '5' ? {display: 'block'} : {display: 'none'}}>
                <label>
                  رساننده <span className="requireFiled">*</span>
                </label>
                <select className="form-control" id="driverId" name="driverId">
                  <option value="">---------</option>
                  {this.state.Drivers.map((driver, index) => (
                    <option key={`driver${index}`} value={driver.personId}>
                      {driver.name}
                    </option>
                  ))}
                </select>
              </div>

              <label>شناسه خارجی انبار</label>
              <input type="number" className="form-control" min="1" id="externalId" name="externalId" />

              <label>اولویت نمایش</label>
              <input
                type="number"
                defaultValue="1000"
                className="form-control"
                min="1"
                id="sortOrder"
                name="sortOrder"
              />

              <button className="form-control btn btn-info" onClick={this.submitWarehouse.bind(this)}>
                ثبت نهایی
              </button>
              {this.renderRedirect()}
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddWarehouse
